module.exports = __webpack_public_path__ + "img/btn4.6584f774.png";